import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (setupID, setupIndex, refresh) {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: '',
    name: 'productInspectionSettingDetailsGet',
    method: 'GET'
  });
  useEffect(() => {
    if (setupID && setupIndex) {
      exec({ url: '/api/inspection_product_configs/details?inspect_prod_main_oid=' + setupID + '&inspect_type=' + setupIndex })
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setupID, setupIndex, refresh]);
  return [isRequestSuccessed, data || [], exec];
})